export default __webpack_public_path__ + "static/media/RS.ebc3a9f0.ico";